export const PopupProgressComponent = {
  bindings: {
    title: '@',
    desc: '@',
    nbTotal: '<',
    nbCurrent: '<',
  },
  templateUrl: 'components/Popup/popup-progress/popup-progress.html',
};
